/*
 *
 * NotificationEngine constants
 *
 */

export const NOTIFICATION_TYPE_GENERAL = 'info';
export const NOTIFICATION_TYPE_SUCCESS = 'success';
export const NOTIFICATION_TYPE_WARN = 'warning';
export const NOTIFICATION_TYPE_ERROR = 'danger';

export const NOTIFICATION_TIMEOUT_NONE = -1;
export const NOTIFICATION_TIMEOUT_DEFAULT = 3000;

export const SHOW_NOTIFICATION = 'app/NotificationEngine/SHOW_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'app/NotificationEngine/DISMISS_NOTIFICATION';
